// initial state

import * as base from './base.js'
const baseName = '/admin/system/user'
const menubaseName = '/admin/system/menu'
const menuTwobaseName = '/admin/system/menu/m'
const rolebaseName = '/admin/system/role'
const withdrawName = '/admin/api/userWithdraw'
const arecordRecordsName = '/admin/api/userAccountRecords'
const rechargeName = '/admin/api/userRecharge'
const bankName = '/admin/api/userLevel'
const realName = '/admin/api/userReal'
const whiteName = '/admin/api/userWhite'
const blackName = '/admin/api/userBlack'
const repairmanName = '/admin/system/maiUser'
const cusUserName = '/admin/system/cusUser'


const userQueryMoney = baseName + '/queryMoney'
const systemUserList = baseName + '/list' //获取用户列表
const userQueryMonthMoney = baseName + '/queryMonthMoney'
const userRechargeRecharge = rechargeName + '/recharge'

const obj = base.setBaseUrl('user', baseName)
const obj1 = base.setBaseUrl('userWithdraw', withdrawName)
const obj2 = base.setBaseUrl('userAccountRecords', arecordRecordsName)
const obj3 = base.setBaseUrl('userBank', bankName)
const obj4 = base.setBaseUrl('userReal', realName)
const obj5 = base.setBaseUrl('userRecharge', rechargeName)
const obj6 = base.setBaseUrl('userWhite', whiteName)
const obj7 = base.setBaseUrl('userBlack', blackName)
const obj8 = base.setBaseUrl('repairman', repairmanName)
const obj9 = base.setBaseUrl('systemUserList', systemUserList)
const obj10 = base.setBaseUrl('role', rolebaseName)
const obj11 = base.setBaseUrl('menu', menubaseName)
const obj12 = base.setBaseUrl('menu2', menuTwobaseName)
const obj13 = base.setBaseUrl('cusUser', cusUserName)


const a = Object.assign(obj, obj1, obj2, obj3, obj4, obj5, obj6, obj7, obj8, obj9, obj10, obj11,obj12,obj13, { userQueryMoney, systemUserList, userQueryMonthMoney, userRechargeRecharge })
export default a
